const goToHelpLink = (url) => {
  window.open(url, "_blank", "noopener,noreferrer");
};

export default goToHelpLink;
